import cn from "mcn";
import { forwardRef } from "react";

export const CatalogueIcon = forwardRef<
  SVGSVGElement,
  React.HTMLAttributes<SVGSVGElement> & {
    selected?: boolean;
    disabled?: boolean;
  }
>(function CatalogueIcon({ selected, disabled, ...props }, ref) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: We have a custom tooltip
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width="42"
      height="42"
      viewBox="0 0 42 42"
      fill="none"
      {...props}
      className={cn("catalogue-icon nav-icon", { selected }, disabled ? "opacity-50" : "", props.className)}
    >
      <rect className="background" opacity="0.15" width="42" height="42" rx="6" fill="white" />
      <g transform="translate(4, 4)">
        <path
          d="M13.0714 8.35714V13.0714H8.35714V8.35714H13.0714ZM8.35714 6C7.0558 6 6 7.0558 6 8.35714V13.0714C6 14.3728 7.0558 15.4286 8.35714 15.4286H13.0714C14.3728 15.4286 15.4286 14.3728 15.4286 13.0714V8.35714C15.4286 7.0558 14.3728 6 13.0714 6H8.35714ZM13.0714 20.9286V25.6429H8.35714V20.9286H13.0714ZM8.35714 18.5714C7.0558 18.5714 6 19.6272 6 20.9286V25.6429C6 26.9442 7.0558 28 8.35714 28H13.0714C14.3728 28 15.4286 26.9442 15.4286 25.6429V20.9286C15.4286 19.6272 14.3728 18.5714 13.0714 18.5714H8.35714ZM20.9286 8.35714H25.6429V13.0714H20.9286V8.35714ZM18.5714 8.35714V13.0714C18.5714 14.3728 19.6272 15.4286 20.9286 15.4286H25.6429C26.9442 15.4286 28 14.3728 28 13.0714V8.35714C28 7.0558 26.9442 6 25.6429 6H20.9286C19.6272 6 18.5714 7.0558 18.5714 8.35714Z"
          fill="white"
        />
        <path
          className="plus-icon"
          d="M23.2857 18.5714C22.6326 18.5714 22.1071 19.0969 22.1071 19.75V22.1071H19.75C19.0969 22.1071 18.5714 22.6326 18.5714 23.2857C18.5714 23.9388 19.0969 24.4643 19.75 24.4643H22.1071V26.8214C22.1071 27.4746 22.6326 28 23.2857 28C23.9388 28 24.4643 27.4746 24.4643 26.8214V24.4643H26.8214C27.4746 24.4643 28 23.9388 28 23.2857C28 22.6326 27.4746 22.1071 26.8214 22.1071H24.4643V19.75C24.4643 19.0969 23.9388 18.5714 23.2857 18.5714Z"
          fill="white"
        />
      </g>
    </svg>
  );
});
